module.exports = __webpack_public_path__ + "img/donante-kempler.92bd8334.jpg";